import { ENROLLMENT_STATE } from '@theailab-dev/parchment';
import type { EnrollmentState } from '@theailab-dev/parchment';

export function getEnrollmentStateBadgeVariant(state: EnrollmentState) {
  switch (state) {
    case ENROLLMENT_STATE.IN_PROGRESS:
      return 'success';
    case ENROLLMENT_STATE.COMPLETED:
      return 'blue';
    case ENROLLMENT_STATE.CREDITED:
      return 'purple';
    case ENROLLMENT_STATE.SUSPENDED:
      return 'warning';
    case ENROLLMENT_STATE.CANCELED:
      return 'danger';
    case ENROLLMENT_STATE.EXPIRED:
    default:
      return 'neutral';
  }
}
